import Cookies from 'js-cookie'

// Default expiration in days
const DEFAULT_EXPIRATION = 7

/**
 * Sets a cookie with the given name and value
 * @param {string} name - The name of the cookie
 * @param {any} value - The value to store (will be stringified if not a string)
 * @param {number} expires - Days until the cookie expires
 */
export const setCookie = (name, value, expires = DEFAULT_EXPIRATION) => {
  // If value is an object, stringify it
  const stringValue = typeof value === 'object' ? JSON.stringify(value) : value
  Cookies.set(name, stringValue, { expires, path: '/' })
}

/**
 * Gets a cookie value by name
 * @param {string} name - The name of the cookie
 * @param {boolean} parseJson - Whether to parse the value as JSON
 * @returns {any} The cookie value, or null if not found
 */
export const getCookie = (name, parseJson = false) => {
  const value = Cookies.get(name)
  if (!value) return null

  if (parseJson) {
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }

  return value
}

/**
 * Removes a cookie by name
 * @param {string} name - The name of the cookie to remove
 */
export const removeCookie = (name) => {
  Cookies.remove(name, { path: '/' })
}

/**
 * Removes all cookies
 */
export const removeAllCookies = () => {
  Object.keys(Cookies.get()).forEach((cookieName) => {
    removeCookie(cookieName)
  })
}
